import RegistrationLogin from './RegistrationLogin';

export default RegistrationLogin;